var _rect, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcBuyBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 176,
    viewBox: "0 0 148 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 147,
    height: 175,
    rx: 23.5,
    fill: "white",
    fillOpacity: 0.02
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 147,
    height: 175,
    rx: 23.5,
    stroke: "url(#paint0_linear_4733_49520)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4733_49520",
    x1: 0,
    y1: 0,
    x2: 143,
    y2: 165.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13AE67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "white",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13AE67"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBuyBorder);
export default __webpack_public_path__ + "static/media/ic-buy-border.91176005cdcfde040b6cc0fa5c36dd57.svg";
export { ForwardRef as ReactComponent };